export default "__VITE_ASSET__CdqziWcr__"